import { Box, Typography, CircularProgress, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { APP_URLS } from '../../../../routes/urls';
import { registeredStatisticsStyles } from './styles';

interface RegisteredStatisticItemProps {
  module: 'Institutes' | 'Programs' | 'Scholarships';
  count?: number;
  isLoading: boolean;
}

export const RegisteredStatisticItem: React.FC<RegisteredStatisticItemProps> = ({ module, count, isLoading }) => {
  const getModuleLink = (): string => {
    switch (module) {
      case 'Institutes':
        return APP_URLS.institutes;
      case 'Scholarships':
        return APP_URLS.scholarships;
      case 'Programs':
        return APP_URLS.programs;
    }
  };

  const getModuleContent = (): string => {
    switch (module) {
      case 'Institutes':
        return `Nepal education portal helps the student to find the best university, colleges and school. Nepal education portal includes the all details of ${
          count || ''
        } institutions which helps students to find the best school and colleges in Nepal`;
      case 'Programs':
        return `Nepal education portal includes ${
          count || 'lots of'
        } academic programs , from where students can choose areas of study according to their interest. Nepal education portal includes 10+2, Bachelor and masters level programs`;
      case 'Scholarships':
        return `Nepal education portal helps student to search and apply right scholarships to right students. Nepal education portal provide ${
          count || 'lots of'
        } scholarship where eligible students can apply to get scholarships`;
    }
  };
  const moduleContent = getModuleContent();
  const moduleLink = getModuleLink();
  return (
    <Box sx={registeredStatisticsStyles.card}>
      <Typography component="h3" variant="h5">
        {isLoading ? (
          <CircularProgress color="secondary" size="1.5rem" />
        ) : (
          <Typography variant="h5" sx={{ bgcolor: 'warning.light' }} component="span">
            {count ? count : 'Lots of'}
          </Typography>
        )}{' '}
        {module}
      </Typography>
      <Typography color="secondary" paragraph sx={{ mt: 2.5, mb: 4 }} variant="medium">
        {moduleContent}
      </Typography>
      <Button variant="default" color="primary" component={Link} to={moduleLink}>
        Explore {module}
      </Button>
    </Box>
  );
};
